import { FetchTemplatesRequest } from '../../templates/templates.actions'
import { getTemplatesState } from '../../templates/templates.selectors'
import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateField,
  SetDefaultData,
  CreateCommercialLicenseMappingRequest,
} from '../commercial-license-mappings.actions'
import { getCreateCommercialLicenseMappingState } from '../commercial-license-mappings.selectors'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'

@Component({
  selector: 'app-create-template',
  templateUrl: './create-commercial-license-mapping.component.html',
  styleUrls: ['./create-commercial-license-mapping.component.css'],
})
export class CreateCommercialLicenseMappingComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  private templatesState$: Subscription
  public isLoading: boolean
  public templates: [] = []

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(
      new SetDefaultData('createCommercialLicenseMapping'),
    )
    this.state$ = this.store
      .pipe(select(getCreateCommercialLicenseMappingState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })
    this.templatesState$ = this.store
      .pipe(select(getTemplatesState))
      .subscribe((state) => {
        this.templates = state.get('data').toJS()
      })

    this.store.dispatch<any>(
      new FetchTemplatesRequest({
        pageSize: 500,
      }),
    )
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.templatesState$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'createCommercialLicenseMapping.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'createCommercialLicenseMapping',
      ),
    )
  }

  private validation() {
    const data = this.state.get('data')
    const rules = {
      propertyType: 'required',
      rate: 'required|numeric',
      templateId: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()
    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new CreateCommercialLicenseMappingRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'createCommercialLicenseMapping',
        ),
      )
    }
  }
}
